import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdInterface, TestInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateTestUseCaseParams {
    clientId: IdInterface;
    test: TestInterface;
    requiredSignature?: boolean;
}

@Injectable()
export class UpdateTestUseCase implements UseCaseWithParam<UpdateTestUseCaseParams, Observable<Transaction<void>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: UpdateTestUseCaseParams): Observable<Transaction<void>> {
        return this.testProvider.update(params.clientId, params.test, params.requiredSignature || false);
    }
}
